import type { FC } from "react";

import {
  ACCORDION_TRIGGER_ICON,
  type TAccordionTriggerIconProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const AccordionTriggerIcon: FC<TAccordionTriggerIconProps> = (
  {
    className,
    ...props
  },
) => (
  <div
    data-component="AccordionTriggerIcon"
    className={cn("w-6 h-6 flex justify-center items-center", className)}
    {...props}
  >
    <Icon
      icon={ACCORDION_TRIGGER_ICON}
      aria-hidden="true"
      size="sm"
    />
  </div>
);

AccordionTriggerIcon.displayName = "AccordionTriggerIcon";
